<template>
    <Head :title="pageTitle"/>
    <google-analytics-inertia/>
    <FlashMessages/>
    <HoneybadgerErrorTracking/>
    <div class="flex min-h-screen flex-col">
        <group-header v-if="!hideHeader"/>

        <main class="flex flex-grow bg-white">
            <slot/>
        </main>
    </div>
</template>

<script>
import GroupHeader from "@/Components/GroupHeader";
import InlineSvg from "vue-inline-svg";
import FlashMessages from "@/Components/FlashMessages";
import GoogleAnalyticsInertia from "@/Components/GoogleAnalyticsInertia.vue";
import HoneybadgerErrorTracking from "@/Components/HoneybadgerErrorTracking.vue";

export default {
    name: "GroupCheckoutLayout",
    components: {
        HoneybadgerErrorTracking,
        GoogleAnalyticsInertia,
        FlashMessages,
        InlineSvg,
        GroupHeader,
    },
    props: {
        hideHeader: {
            type: Boolean,
            default: false,
        },
        pageTitle: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            menuItems: this.$page.props.menuItems,
        };
    },
};
</script>

<style scoped></style>
